import { IconSize } from './interfaces';

export const ICONS_BASE_URL =
  process.env.ICONS_BASE_URL || 'https://assets.aws-dev.enercity.de/icons';

export const MEDIUM_ICON_MAX_SIZE: IconSize = 'iconSize48';
